import {useLayoutEffect} from "react";
import {useLocation} from "react-router-dom";
import {
    isPublicSitePath,
} from "../../presentation/public-site/route-policy";

export default function RouteRootClass() {
    const {pathname} = useLocation();

    useLayoutEffect(() => {
        const root = document.getElementById("root");

        if (!root) {
            return undefined;
        }

        const isPublicSitePage = isPublicSitePath(pathname);

        root.classList.toggle(
            "public-site",
            isPublicSitePage
        );
        root.classList.toggle(
            "main-page",
            pathname === "/"
        );
        root.classList.toggle(
            "theme",
            !isPublicSitePage
        );

        return undefined;
    }, [pathname]);

    return null;
}